var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.loading)?_c('Loading'):_vm._e(),_c('Simplert',{ref:"notif",attrs:{"useRadius":true,"useIcon":true}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }